module.exports = __webpack_public_path__ + "img/top-b-back2.7290b613.png";